import type { CategorizationRule, KeywordMapping } from '../types';

export const RULES: CategorizationRule[] = [
  {
    category: "Bills & Utilities",
    keywords: [
      "electric",
      "comed",
      "gas bill",
      "water bill",
      "internet",
      "phone bill",
      "comcast",
      "xfinity",
      "verizon",
      "at t",
      "t mobile",
      "mint mobile",
      "sprint",
      "spectrum",
      "cox communications",
      "centurylink",
      "frontier comm",
      "waste management",
      "recycling",
      "trash service",
      "water district",
      "sewer",
      "energy services",
      "energy",
      "commonwealth edison",
      "directv",
      "dish network",
      "siriusxm",
      "sirius",
      "xm radio",
    ],
  },
  {
    category: "Insurance",
    keywords: [
      "state farm",
      "insurance",
      "geico",
      "allstate",
      "progressive",
      "mass mutual",
      "capital one auto",
      "liberty mutual",
      "farmers insurance",
      "usaa",
      "nationwide",
      "travelers",
    ],
  },
];

export const DISPLAY_NAMES: KeywordMapping[] = [
  { keyword: "comcast", displayName: "Comcast" },
  { keyword: "xfinity", displayName: "Xfinity" },
  { keyword: "comed", displayName: "ComEd" },
  { keyword: "verizon", displayName: "Verizon" },
  { keyword: "at t", displayName: "AT&T" },
  { keyword: "t mobile", displayName: "T-Mobile" },
  { keyword: "state farm", displayName: "State Farm" },
  { keyword: "geico", displayName: "Geico" },
];
